var BaseCollection = require('./base-collection');
var SnomedModel = require('../models/snomed-model');

var SnomedCollection = Backbone.Collection.extend({
    url:"https://snomed.reviewandsign.org/snomed/en-edition/v20140731/concepts",
    model: SnomedModel,

    initialize: function(models, options) {
        if (options){
            if (options.parent){
                this.url += "/" + options.parent;
            }
            if (options.children){
                this.url += "/children";
            }
        }
    }

});


module.exports = SnomedCollection;


//////////////////
// WEBPACK FOOTER
// ./app/collections/snomed-collection.js
// module id = 350
// module chunks = 0